<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Berita Acara Stock Opname" active>

                                <b-row v-if="hasFailedDataBeritaAcaraStockOpname">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedBeritaAcaraStockOpname.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="beritaAcaraStockOpnamesFailed" :fields="fieldsBeritaAcaraStockOpname" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBeritaAcaraStockOpname" :sort-desc.sync="sortDescBeritaAcaraStockOpname" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedBeritaAcaraStockOpname.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="beritaAcaraStockOpnames" :fields="fieldsBeritaAcaraStockOpname" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBeritaAcaraStockOpname" :sort-desc.sync="sortDescBeritaAcaraStockOpname" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import BeritaAcaraStockOpname from '@/models/BeritaAcaraStockOpname/BeritaAcaraStockOpname';
import BeritaAcaraStockOpnameList from '@/models/BeritaAcaraStockOpname/BeritaAcaraStockOpnameList';
import BeritaAcaraStockOpnameFilter from '@/filters/BeritaAcaraStockOpname/BeritaAcaraStockOpnameFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsBeritaAcaraStockOpname: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Stock Opname Plan", key: 'stockOpnamePlanName', sortable: false},
				{"class" : "th-status", "label" : "Area", key: 'areaCode', sortable: false},
				{"class" : "th-status", "label" : "Vendor", key: 'vendorCode', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			beritaAcaraStockOpnames : [],
			beritaAcaraStockOpnamesFailed: [],
			beritaAcaraStockOpnameId : '',
			sortByBeritaAcaraStockOpname: '',
			sortDescBeritaAcaraStockOpname: '',
			hasFailedDataBeritaAcaraStockOpname: false,
			totalFailedBeritaAcaraStockOpname: 0,
			totalSucceedBeritaAcaraStockOpname: 0,

			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('beritaacarastockopname/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('beritaacarastockopname/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getBeritaAcaraStockOpnameForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getBeritaAcaraStockOpnameForUpload : async function() {
			let _this = this;
			this.$http.get('beritaacarastockopname/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.beritaAcaraStockOpnames = [];


					if (response != null) {
						let result = response.data;
						_this.beritaAcaraStockOpnames = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedBeritaAcaraStockOpname = _this.beritaAcaraStockOpnames.length;

						_this.beritaAcaraStockOpnamesFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataBeritaAcaraStockOpname = true;
						_this.totalFailedBeritaAcaraStockOpname = 0;
						if(_this.beritaAcaraStockOpnamesFailed == undefined || _this.beritaAcaraStockOpnamesFailed.length === 0) _this.hasFailedDataBeritaAcaraStockOpname = false;
						if(_this.hasFailedDataBeritaAcaraStockOpname) _this.totalFailedBeritaAcaraStockOpname = _this.beritaAcaraStockOpnamesFailed.length;

						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'beritaacarastockopname/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'BeritaAcaraStockOpname.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterBeritaAcaraStockOpname = new BeritaAcaraStockOpnameFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
